import React from "react";
import { Collapse, ConfigProvider, Image, Row, Skeleton } from "antd";
import {
  colorArrowCollapsedCourse,
  textDescHelpTopics,
  backgroundHeaderContentHelpTopics,
  headerBgListItemHelpTopics,
  contentBgListItemHelpTopics,
  textTitleItemHelpTopics,
  colorTextTitle,
  linkEmailText,
  backgroundLinkElement,
} from "../../../../../../config/constant/color";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import Banner from "../../../../../../assets/images/png/help/img_banner_help.png";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import ic_email_helpcenter from "../../../../../../assets/images/svgs/ic_email_helptopics.svg";
import {
  contactEmail,
  subjectEmail,
  bodyEmail,
} from "../../../../../../config/constant/customer_support/index";
import { getAppName } from "../../../../../../utils";
import { useLocation } from "react-router-dom";
// for translate
import { useTranslation, Trans } from "react-i18next";
const Others = () => {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const data = location.state?.data;

  const screens = useBreakpoint();
  const isMobileVersion = screens.xs;
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);

  const listCollapseStyling =
    isMobileVersion || isScallingVersion
      ? {
          fontWeight: "500",
          fontSize: "12px",
          lineHeight: "15px",
        }
      : {
          fontWeight: "500",
        };

  const items = [
    {
      key: "1",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="0">
          <Trans i18nKey="feature.help_content.others.t_1.title" />
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <Trans i18nKey="feature.help_content.others.t_1.desc_1" />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="1">
          <Trans i18nKey="feature.help_content.others.t_2.title" />
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <Trans i18nKey="feature.help_content.others.t_2.desc_1" />
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="2">
          <Trans i18nKey="feature.help_content.others.t_3.title" />
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            <Trans i18nKey="feature.help_content.others.t_3.desc_1" />
          </div>
        </div>
      ),
    },
  ];

  const emailTo = () => {
    const body = bodyEmail;
    const replaceName = body.replace("___", data?.userData.userName);
    const replaceUsername = replaceName.replace(
      "***",
      data?.detailUser.username,
    );
    const bodyEmailCombine = replaceUsername.replace("###", getAppName());

    const replaceSubject = subjectEmail.replace("###", getAppName());

    window.open(`mailto: ${contactEmail}?subject=${replaceSubject}&body=${bodyEmailCombine}`);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: headerBgListItemHelpTopics,
            headerPadding: "20px",
            contentBg: contentBgListItemHelpTopics,
            contentPadding: "0 20px 20px 20px",
          },
        },
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      <div style={{ position: "relative", height: "100%" }}>
        {!(isMobileVersion || isScallingVersion) && (
          <div
            style={{
              height: "130px",
              borderRadius: "0 0 16px 16px",
            }}
          >
            <div
              style={{
                color: "#FFF",
                textAlign: "center",
                position: "relative",
                borderRadius: "0 0 16px 16px",
                display: "grid",
                gridTemplateColumns: "1fr",
              }}
            >
              <h3
                style={{
                  margin: "0",
                  height: "100%",
                  color: "#000",
                  lineHeight: "160px",
                  textAlign: "center",
                  gridRowStart: 1,
                  gridColumnStart: 1,
                }}
              >
                1
              </h3>
              <img
                alt={`Banner_default`}
                style={{
                  width: "100%",
                  height: "130px",
                  objectFit: "cover",
                  objectPosition: "right",
                  gridRowStart: 1,
                  gridColumnStart: 1,
                  borderRadius: "0 0 16px 16px",
                }}
                src={Banner}
              />
            </div>
          </div>
        )}
        {(isMobileVersion || isScallingVersion) && (
          <div
            style={{
              width: "100%",
              height: 48,
              marginTop: "-14px",
              borderBottomRightRadius: "16px",
              borderBottomLeftRadius: "16px",
              background: backgroundHeaderContentHelpTopics,
            }}
          ></div>
        )}

        <div
          className={
            isMobileVersion || isScallingVersion
              ? "list-collapse-mobile"
              : "list-collapse"
          }
          style={{
            padding:
              isMobileVersion || isScallingVersion
                ? "24px 18px"
                : "0 42px 25px 42px",
            top: isMobileVersion || isScallingVersion ? "0" : "-130px",
            position: "relative",
            marginTop: isMobileVersion || isScallingVersion ? "-57px" : "0",
          }}
        >
          {!(isMobileVersion || isScallingVersion) && (
            <div style={{ height: "95px", padding: "20px 0 20px 11%" }}>
              <div
                text-title="text-title-banner-others-help-center"
                style={{
                  color: "#FFFF",
                  fontWeight: "500",
                  fontSize: "22px",
                  marginBottom: "5px",
                }}
              >
                {t("feature.feature_help.main_header.assistance_prompt")}
              </div>
              <div
                text-title="text-subtitle-banner-others-help-center"
                style={{ color: "#FFFF", fontWeight: "600", fontSize: "14px" }}
              >
                {t("feature.feature_help.main_header.showing")}{" "}
                <span
                  style={{
                    color: textTitleItemHelpTopics,
                    background: "#FFF",
                    padding: "3px 5px",
                    borderRadius: "2px",
                  }}
                >
                  {t("feature.feature_help.side_dpd.others")}
                </span>{" "}
                {t("feature.feature_help.main_header.showing_topic")}
              </div>
            </div>
          )}

          <Collapse
            className="align-items-center collapsed-learning-journey"
            style={{ border: "1px #E5E5E6 solid" }}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <span
                style={{
                  backgroundColor: colorArrowCollapsedCourse,
                  borderRadius: "50%",
                  padding: "6px",
                }}
              >
                {isActive ? <UpOutlined /> : <DownOutlined />}
              </span>
            )}
            bordered={false}
            accordion={true}
            destroyInactivePanel={true}
            items={items}
          />

          {(isMobileVersion || isScallingVersion) && (
            <div
              style={{
                padding: "18px",
                width: "100%",
                borderRadius: "8px",
                backgroundColor: backgroundLinkElement,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: colorTextTitle,
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                >
                  {t("feature.feature_help.side_dpd.contact_more_help")}
                </div>
                <a
                  onClick={() => {
                    data?.loadingProfile ? "" : emailTo();
                  }}
                  style={{
                    padding: "0",
                    color: linkEmailText,
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                  id="btn-link-contact-help-center"
                >
                  <span style={{ marginRight: "6px" }}>
                    <Image src={ic_email_helpcenter} preview={false} />
                  </span>
                  {data?.loadingProfile ? <Skeleton.Input /> : contactEmail}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default Others;
